import PropTypes from "prop-types";
import { isNil } from "ramda";

import StarringYou from "pages/Home/components/StarringYou";
import AlgoliaCardsPresenter from "presenters/AlgoliaCardsPresenter";
import SearchBoxGeneric from "components/SearchBoxGeneric";
import MenuItemPresenter from "presenters/MenuItemPresenter";
import SearchResults from "components/SearchResults";
import { useHomePage } from "hooks";

const AlgoliaFeaturedEcards = ({ algoliaCard, initialQueryObject }) => {
  const { viewMoreButton } = useHomePage();
  const content = {
    viewMoreText: isNil(viewMoreButton) ? "" : MenuItemPresenter.linkText(viewMoreButton),
    viewMoreUrl: isNil(viewMoreButton) ? "" : MenuItemPresenter.linkTo(viewMoreButton),
    sectionSubHeaderText: isNil(algoliaCard) ? "" : AlgoliaCardsPresenter.title(algoliaCard),
  };

  return (
    <SearchBoxGeneric
      initialQueryObject={initialQueryObject}
      searchResultsSkeletonSlot={<StarringYou loading />}
      resultsSlot={SearchResults}
      resultsSlotProps={{
        WrappedComponent: StarringYou,
        content,
      }}
    />
  );
};

AlgoliaFeaturedEcards.propTypes = {
  algoliaCard: PropTypes.shape(),
  initialQueryObject: PropTypes.shape(),
};

export default AlgoliaFeaturedEcards;
